import { useMemo } from 'react';
import { mapQueries, Acceptance } from '@gv/triage-components';

import { PetSpecies } from 'types';
import { useListQuery } from 'store/api/species';
import { useGetQuery } from 'store/api/acceptance';
import { useGetHospitalQuery } from 'store/api/hospital-bitwerx';
import { useListQuery as useListQueryBitwerx } from 'store/api/species-bitwerx';

type SpeciesQuery = {
  acceptance: Acceptance;
  speciesList: PetSpecies[];
};

export const useSpeciesProps = (hospitalId?: number | string) => {
  const { acceptance, speciesList, ...rest } = mapQueries<SpeciesQuery>({
    speciesList: useListQuery(),
    acceptance: useGetQuery(
      { hospitalId: String(hospitalId) },
      { skip: !hospitalId }
    ),
  });

  const { data: hospitalBitwerx }: any = useGetHospitalQuery({
    id: hospitalId,
  });
  const bitwerxStatus = useMemo(() => {
    return Boolean(hospitalBitwerx?.response?.bitwerx_practice_id);
  }, [hospitalBitwerx]);

  const { data: dataBitwerx } = useListQueryBitwerx({ id: hospitalId });

  const acceptableSpecies = useMemo(
    () => acceptance?.species?.map((item) => item.name) ?? [],
    [acceptance?.species]
  );

  const notAcceptableSpecies = useMemo(() => {
    const options: string[] = [];

    if (bitwerxStatus) {
      if (dataBitwerx?.length) {
        dataBitwerx.forEach(({ name }) => {
          if (name && !acceptableSpecies.includes(name)) {
            options.push(name);
          }
        });
      }
    } else if (speciesList?.length) {
      speciesList.forEach(({ name }) => {
        if (name && !acceptableSpecies.includes(name)) {
          options.push(name);
        }
      });
    }

    return options;
  }, [speciesList, dataBitwerx, bitwerxStatus, acceptableSpecies]);

  return { acceptableSpecies, notAcceptableSpecies, ...rest };
};
